import React from 'react';
import { HistoriquePrixProduit } from '../../../../../common/src/entities';
import Facturation from '../../../../../common/src/entities/facturation.entity';

export function getCurrentPrice(historyPrice: HistoriquePrixProduit[]): HistoriquePrixProduit | undefined {
    const currentDate = new Date();

    const sortedHistory = historyPrice?.sort((a, b) => {
        return a.date_debut > b.date_debut ? -1 : 1;
    });

    return sortedHistory?.find((prix) => new Date(prix.date_debut) <= currentDate);
}

export function clientPrice(lastPrice: HistoriquePrixProduit) {
    if (!lastPrice) return 'N/A';
    let total = lastPrice.facturation?.prix_de_vente_fournisseur;

    const prix = lastPrice.facturation?.prix_de_vente_fournisseur;
    const pourcentage =
        lastPrice.facturation?.valeur_surfacturation_pourcentage === 0
            ? 0
            : +lastPrice.facturation?.valeur_surfacturation_pourcentage / 100;
    const surfacturation = lastPrice.facturation?.valeur_surfacturation_dollar;
    return +total + (+prix * +pourcentage + +surfacturation);
}

export function affichageComms(info: HistoriquePrixProduit) {
    if (!info) return 'N/A';
    const cd = info.facturation?.valeur_commission_dollar.toString();
    const cp = info.facturation?.valeur_commission_pourcentage.toString();
    const sd = info.facturation?.valeur_surfacturation_dollar.toString();
    const sp = info.facturation?.valeur_surfacturation_pourcentage.toString();
    const commission = `${
        cd !== '0' || cp !== '0'
            ? `[C:${cp !== '0' ? cp + '%' : ''}${cd !== '0' && cp !== '0' ? ' ' : ''}${cd !== '0' ? cd + '$' : ''}] `
            : ''
    }`;
    const surfacturation = `${
        sd !== '0' || sp !== '0'
            ? `[S:${sp !== '0' ? sp + '%' : ''}${cd !== '0' && cp !== '0' ? ' ' : ''}${sd !== '0' ? sd + '$' : ''}] `
            : ''
    }`;
    return commission + surfacturation;
}

export function errorPrice() {
    return (
        <div
            style={{
                cursor: 'pointer', // Curseur en forme de main au survol
                position: 'relative',
            }}
            className="row-null"
            title="Attention : l'objet est null"
        >
            {
                <p
                    style={{
                        fontSize: '20',
                    }}
                >
                    Prix non configuré
                </p>
            }
        </div>
    );
}

export function getTotalCommission(historiquePrixProduit: HistoriquePrixProduit) {
    return getTotalCommissionFacture (historiquePrixProduit.facturation); 
}

export function getTotalSurfacturation(historiquePrixProduit: HistoriquePrixProduit) {
    return getTotalSurfacturationFacture(historiquePrixProduit.facturation);
}

export function getTotalCommissionFacture(facturation: Facturation) {
    const prix = facturation.prix_de_vente_fournisseur;
    const pourcentage = facturation.valeur_commission_pourcentage / 100;
    const commission = facturation.valeur_commission_dollar;
    return Number(prix) * Number(pourcentage) + Number(commission);
}

export function getTotalSurfacturationFacture(facturation: Facturation) {
    const prix = facturation.prix_de_vente_fournisseur;
    const pourcentage = facturation.valeur_surfacturation_pourcentage / 100;
    const surfacturation = facturation.valeur_surfacturation_dollar;
    return Number(prix) * Number(pourcentage) + Number(surfacturation);
}